/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import _throttle from 'lodash/throttle'
import { Container, Row, Col } from '@cx/couturier/Grid'
import styled, { css } from 'styled-components'
import Button from '@cx/couturier/Button'
import IconUtilClose from '@cx/couturier/icons/utils/Close'
import HelpAltIcon from '@cx/couturier/icons/utils/HelpAlt'
import parseSupportTelNums from '../../utils/format-phone'

const ResponsiveText = styled.p`
  && {
    bottom: 0.25rem;
    display: none;
    font-size: 14px;
    left: 0.25rem;
    letter-spacing: 0.5px;
    position: relative;
    top: 0px;

    ${({ theme: { media } }) =>
      media.medium(css`
        display: inline-block;
      `)};
  }
`

const AdjustedHelpIcon = styled(HelpAltIcon)`
  height: 25px;
`

const HelpPanelIcon = ({ onOpen, description, isOpen }) => {
  if (onOpen) {
    return (
      <div className="ui-help-panel-trigger">
        <a
          aria-label={`Open ${description}`}
          className="ui-help-panel-open"
          id="help-panel-open"
          onClick={onOpen}
          tabIndex={isOpen ? -1 : 0}
          tertiary="true"
        >
          <AdjustedHelpIcon />
          <ResponsiveText>Help</ResponsiveText>
        </a>
      </div>
    )
  }

  return null
}

const CloseButton = ({ onClose, description, isOpen }) => {
  if (onClose) {
    return (
      <div className="ui-help-panel-close-container">
        <Button
          aria-label={`Close ${description}`}
          className="ui-help-panel-close help-panel-link"
          id="help-panel-close"
          onClick={onClose}
          tabIndex={isOpen ? 0 : -1}
          tertiary
        >
          <IconUtilClose />
        </Button>
      </div>
    )
  }

  return null
}

class HelpPanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.keyDownListener = _throttle(this.keyDownListener.bind(this), 100)
  }

  componentDidMount() {
    // add listeners
    // Check if document is defined before using
    if (document !== undefined) {
      document.addEventListener('keydown', this.keyDownListener, true)
    }
  }

  componentDidUpdate() {
    // ADA focus on Help Panel CTAs
    if (this.state.isOpen) {
      document.getElementById('help-panel-close').focus()
    } else {
      document.getElementById('help-panel-open').focus()
    }
    // TODO: close help panel on Escape Key press.
  }

  componentWillUnmount() {
    // remove listeners
    // Check if document is defined before using
    if (document !== undefined) {
      document.removeEventListener('keydown', this.keyDownListener, true)
    }
  }

  activateHelpPanel() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  keyDownListener(e) {
    const escapeKeyCode = 27
    // Check if document is defined before using
    if (document !== undefined) {
      switch (e.keyCode) {
        case escapeKeyCode:
          // collapse HelpPanel
          if (this.state.isOpen) {
            this.activateHelpPanel()
          }
          break
        default:
          break
      }
    }
  }

  render() {
    const { supportHours } = this.props
    const parsedTele = parseSupportTelNums(supportHours.item.telephone, this.state.isOpen)

    // base class Names
    const baseClass = classNames('ui-help-panel', {
      'is-open': this.state.isOpen
    })

    return (
      <aside className={baseClass}>
        <HelpPanelIcon
          description="Open Financial Representative help panel"
          isOpen={this.state.isOpen}
          onOpen={() => {
            this.activateHelpPanel()
          }}
        />
        <div className="ui-help-panel-container">
          <h4 className="assistive-text">Help Panel</h4>
          <CloseButton
            description="Close Financial Representative help panel"
            isOpen={this.state.isOpen}
            onClose={() => {
              this.activateHelpPanel()
            }}
          />
          <Container className="content">
            <Row>
              <Col className="cs">
                <p className="cs-sub-heading">Have technical questions&#63;</p>
              </Col>
            </Row>
            <Row>
              <Col className="cs">
                <h5 className="ui-h6 cs-heading">Contact Customer Service</h5>

                <p className="cs-tels">{parsedTele}</p>
                <p className="cs-hours">{supportHours.item.hours}</p>
              </Col>
            </Row>
          </Container>
        </div>
      </aside>
    )
  }
}

function mapStateToProps(state) {
  return {
    supportHours: state.meta.supportHours
  }
}

export default connect(mapStateToProps)(HelpPanel)
